import { ProjectStatus } from '../../common/constants'
import api from '../../components/api'
import { DuplicateMutationData } from './workareaQueries'
import { RecurringSchedule } from '../recurringSchedule'

export type WorkareaUpdate = {
  jobId: number
  workareaId: number
  fieldsToUpdate: string[]
  name?: string
  status?: ProjectStatus
  divisionId?: number
  costCodeId?: number
  notes?: string
  customLaborRateItemId?: number | null 
  quotedPrice?: number
  customQuotedPrice?: number | null
  completedDate?: string | null
  showTaxInFinalPrice?: boolean
  isOnHold?: boolean
  isApproved?: boolean,
  customerAndInvoiceNotes?: string
  invoiceDescription?: string
}

export const updateWorkarea = async (update: WorkareaUpdate) => {
  return await api.post(`/web/workareas/${update.workareaId}`, update)
}

export const deleteWorkarea = async (workareaId: number) => {
  return await api.delete(`/web/workareas/${workareaId}`)
}

export const duplicateWorkarea = async (data: DuplicateMutationData): Promise<number> => {
  return (await api.post(`/web/workareas/${data.workareaId}/duplicate`, data.form)).data.workareaId
}

export type CreateWorkareaRequest = {
  name: string
  costCodeId: number
  divisionId: number
  jobId: number
  groupId?: string
}

export const createWorkarea = async (request: CreateWorkareaRequest): Promise<number> => {
  return (await api.post(`/web/workareas`, request)).data.workareaId
}

export const updateRecurringSchedule = async (workareaId: number, schedule: RecurringSchedule) => {
  return await api.post(`/web/workareas/${workareaId}/recurring-schedule`, schedule)
}

type SyncRecurringWorkareasRequest = {
  jobId: number
  masterWorkareaId: number
  removeNonMatchingItems: boolean
}

export const syncRecurringWorkareas = async (request: SyncRecurringWorkareasRequest) => {
  return await api.post(`/web/workareas/sync-recurring`, request)
}